import * as routes from './Routes';
import * as tools from '../Tools';

export default class EntryRemove {
    constructor() {
        document.querySelectorAll('.btn-hvd-trash').forEach((btn: HTMLElement) => {
            btn.addEventListener('click', async () => {
                let entryItem = btn.closest('.reportwesen-card.toggle-body');
                if (confirm('Sicher das Sie diesen Eintrag löschen möchten?')) {
                    const removed = await tools.fetchJSON(
                        routes.RWFormSave + 'rm&eid=' + btn.dataset.eid
                    );
                    if (removed.toast) {
                        window.tools.toast(removed.toast[0], removed.toast[1]);
                        entryItem.remove();
                    }
                }
            });
        });
    }
}
